import { useEffect, useState } from "react";

const TextAreaInput = ({ initialFieldData, fieldDataExists, postToDB, putToDB, readOnly, odooData, hasOdooMapping }) => {
	const [currentValue, setCurrentValue] = useState("");

	useEffect(() => {
		let newValue = "";
		if (fieldDataExists) {
			newValue = initialFieldData.value;
		}

		if (hasOdooMapping) {
			if (odooData && odooData.odoo_value !== "failedtogetdataforpmscode400") {
				newValue = odooData.odoo_value;
			} else if (odooData && odooData.odoo_value === "failedtogetdataforpmscode400") {
				if (fieldDataExists) {
					newValue = initialFieldData.value;
				}
			} else {
				newValue = "";
			}
		}
		setCurrentValue(newValue);
	}, [initialFieldData, fieldDataExists, odooData, hasOdooMapping]);

	const sendToDb = () => {
		if (fieldDataExists === false && currentValue !== "") {
			postToDB(currentValue);
		} else if (fieldDataExists) {
			putToDB(currentValue);
		}
	};

	const handleChange = (e) => {
		if (e.target.value.length <= 5000) {
			setCurrentValue(e.target.value);
		}
	};

	if (readOnly) {
		return (
			<div>
				<p className="rounded-lg border border-2 p-2 border-gray w-full whitespace-pre-wrap bg-gray-100">{currentValue || "\u00A0"}</p>
			</div>
		);
	}

	return (
		<form>
			<textarea
				type="text"
				rows={4}
				value={currentValue}
				onChange={handleChange}
				onBlur={() => sendToDb()}
				className="rounded-lg border border-2 p-2 border-gray w-full whitespace-pre-wrap"
				readOnly={readOnly}
			/>
			<p>{currentValue ? currentValue.length : 0}/5000</p>
		</form>
	);
};

export default TextAreaInput;
